export const manifest = {
  screens: {
    scr_xn2fw9: { name: "Home", route: "/" },
  },
}
